// import { motion } from 'framer-motion';

// const steps = [
//   {
//     id: 1,
//     title: 'Fill the Application Form',
//     icon: '/icons/form-icon.svg', // Replace with actual image path
//   },
//   {
//     id: 2,
//     title:
//       'Get redirected to our online registration portal after submitting the form',
//     icon: '/icons/redirect-icon.svg', // Replace with actual image path
//   },
//   {
//     id: 3,
//     title: 'Complete your registration process by making the payment',
//     icon: '/icons/payment-icon.svg', // Replace with actual image path
//   },
//   {
//     id: 4,
//     title: 'Complete your registration process',
//     icon: '/icons/registration-icon.svg', // Replace with actual image path
//   },
// ];

const AdmissionProcess = ({ onApplyClick }) => {
  return (
    <div className="bg-white text-[#1a1a50] py-12 px-4 md:px-8 text-center">
      <div className="flex justify-center">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#2c2087] mb-4 border-b-[3px] border-[#2c2087] py-1">
          Enrollment Guidelines
        </h2>
      </div>
      <p className="mt-2 text-center bg-[#090923] text-white text-base md:text-3xl py-2 px-8 border-2 rounded-3xl inline-block uppercase">
        EASY STEPS TO FOLLOW FOR ADMISSION
      </p>

      <div className="flex flex-wrap justify-center gap-0 mt-10 mb-10">
        {/* {steps.map((step, index) => (
          <motion.div
            key={step.id}
            className="w-72 flex flex-col px-4 items-center text-center"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <motion.div
              className="relative w-32 h-32 bg-[#1a1a50] rounded-full flex items-center justify-center shadow-lg"
              whileHover={{ scale: 1.1 }}
            >
              <img
                src={step.icon}
                alt={`Step ${step.id}`}
                className="w-16 h-16"
              />
              {index !== steps.length - 1 && (
                <div className="absolute right-[-40px] top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white rounded-full flex items-center justify-center">
                  ➝
                </div>
              )}
            </motion.div>

            <h3 className="text-lg font-bold mt-4">{step.id} Step</h3>
            <p className="text-sm mt-2">{step.title}</p>
          </motion.div>
        ))} */}

        <img
          src="assets/admission-process.png"
          alt=""
          className="hidden md:block"
        />
        <img
          src="assets/admission-proces-mobile.png"
          alt=""
          className="block md:hidden"
        />
      </div>
      {/* <button className="bg-yellow-500 duration-300 hover:bg-yellow-600 text-black  text-xl md:text-xl md:font-medium px-20 py-3 rounded-3xl shadow-md transition-all z-20">
        APPLY NOW
      </button> */}
      <button
        onClick={onApplyClick}
        className="mt-2 text-center bg-[#F6A600] hover:bg-[#272262] hover:text-white transition-all duration-300 text-black text-base md:text-3xl py-2 px-32 border-2 rounded-3xl inline-block uppercase"
      >
        APPLY NOW
      </button>
    </div>
  );
};

export default AdmissionProcess;
